// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"397":"e0364dbc","518":"96ef5d2a","520":"7c87aab8","724":"2f0cbf0a","787":"87b59b9a","916":"c2a81864"}[chunkId] + ".chunk.css";
};